import axios from 'axios'
const http = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000
})
// 请求拦截，在每个请求发出去之前，针对每个域名做不同的配置
http.interceptors.request.use(config => {
  if (config.requestBase === 'VUE_APP_API') {
    config.baseURL = process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_TEST === 'true' ? process.env.VUE_APP_TEST_API : process.env.VUE_APP_API
  } else if (config.requestBase === 'VUE_APP_API_TWO') {
    config.baseURL = process.env.NODE_ENV === 'development' ? '/zhengwen' : process.env.VUE_APP_TEST === 'true' ? process.env.VUE_APP_TEST_API_TWO : process.env.VUE_APP_API_TWO
  } else if (config.requestBase === 'VUE_APP_API_THREE') {
    config.baseURL = process.env.NODE_ENV === 'development' ? '/fee' : process.env.VUE_APP_TEST === 'true' ? process.env.VUE_APP_TEST_API_THREE : process.env.VUE_APP_API_THREE
  }
  return config
})
export default http
